// extracted by mini-css-extract-plugin
export default {"point":"styles_point__L4OPX","inner":"styles_inner__oOJMk","private":"styles_private__j+W1-"};